import { axiosRubyClient } from '@/util/axios/axiosClient';

export interface ClosedChatPayload {
  id: string;
  closed_at: string | null;
  closed_by_user_id: number | null;
  closed_by_name: string | null;
  closed_reason: string | null;
}

export interface CloseAllPayload {
  closed_count: number;
}

export class ChatsAdminAPI {
  static async closeChat(
    chatGroupId: string,
    reason?: string,
  ): Promise<ClosedChatPayload> {
    const response = await axiosRubyClient.post(
      `/api/admin/chats/${chatGroupId}/close`,
      reason ? { reason } : {},
    );
    return response.data;
  }

  static async reopenChat(chatGroupId: string): Promise<ClosedChatPayload> {
    const response = await axiosRubyClient.post(
      `/api/admin/chats/${chatGroupId}/reopen`,
    );
    return response.data;
  }

  static async closeAllForWorker(
    workerUserId: number,
    reason?: string,
  ): Promise<CloseAllPayload> {
    const response = await axiosRubyClient.post(
      `/api/admin/workers/${workerUserId}/chats/close_all`,
      reason ? { reason } : {},
    );
    return response.data;
  }
}
